import styled from 'styled-components'
import { themeGet } from 'styled-system'

export const RootWrapper = styled.div`
  padding: 2rem 2.25rem 2.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 29.688rem;
  box-sizing: border-box;
`

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 2.25rem;
  min-height: 2.6875rem;

  ${themeGet('breakpoints.mobile')} {
    flex-direction: column;
  }
`

export const CancelButton = styled.button`
  font-weight: 500;
  background-color: white;
  color: ${themeGet('colors.blue')};
  min-width: 8rem;
  padding: 0.25rem 2.57rem 0 2.57rem;

  box-sizing: border-box;
  border: 2px solid ${themeGet('colors.blue')};
  border-radius: 5px;
  text-align: center;
  &:not([disabled]):hover {
    border-color: ${themeGet('colors.blue')};
    background-color: ${themeGet('colors.blue')};
    color: ${themeGet('colors.white')};
  }
`

export const ConfirmButton = styled.button`
  background-color: ${themeGet('colors.blue')};
  color: ${themeGet('colors.white')};

  margin-left: 1rem;
  min-width: 8rem;
  padding: 0.25rem 2.25rem 0 2.25rem;

  box-sizing: border-box;
  border: 2px solid ${themeGet('colors.blue')};
  border-radius: 5px;
  text-align: center;

  &:not([disabled]):hover {
    background-color: ${themeGet('colors.secondStepBlue')};
    border-color: ${themeGet('colors.secondStepBlue')};
  }
`

export const Header = styled.h2`
  text-align: center;
  font-size: 1.625rem;
  font-family: ${themeGet('fontFamilyHeadingBold')};
  color: ${themeGet('colors.secondStepBlue')};
`
export const Paragraph = styled.div`
  text-align: center;
  font-size: 1.125rem;
  line-height: 1.438rem;
  font-family: ${themeGet('fontFamilySemibold')};
  color: ${themeGet('colors.darkGray')};
  margin-top: 1.25rem;
`
